import { Injectable } from '@angular/core';
import { AiGeneratedPreInterviewQuestions, PreInterviewQuestionsRequest } from '../pre-interview-questions-typings';
import { ApiService } from '../../api.service';
import { Observable } from 'rxjs';
import { HttpHeaders } from "@angular/common/http";
import { PreInterviewQuestion } from "../../../typings";

const yesNoList: string[] = ['Yes', 'No'];

@Injectable({
  providedIn: 'root'
})
export class PreInterviewQuestionsApiService {
  constructor(private apiService: ApiService) {}

  getAllQuestions(orderId: number): Observable<PreInterviewQuestion[]> {
    return this.apiService.httpWrapper<PreInterviewQuestion[]>({
      method: 'GET',
      url: `api/pre-interview/questions/${orderId}`
    });
  }

  getAiGeneratedQuestions(orderId: number): Observable<AiGeneratedPreInterviewQuestions> {
    return this.apiService.httpWrapper<AiGeneratedPreInterviewQuestions>({
      method: 'GET',
      url: `api/pre-interview/ai-generated-questions/${orderId}`
    });
  }

  getSelectedQuestions(orderId: number): Observable<PreInterviewQuestion[]> {
    return this.apiService.httpWrapper<PreInterviewQuestion[]>({
      method: 'GET',
      url: `api/pre-interview/questions/${orderId}/selected`
    });
  }

  savePreInterviewQuestions(request: PreInterviewQuestionsRequest): Observable<void> {
    return this.apiService.httpWrapper<void>({
      method: 'POST',
      url: `api/pre-interview/questions`,
      body: JSON.stringify(request),
      headers: new HttpHeaders({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json'
      })
    });
  }
}
